import { Quaternion, Vector3 } from '@babylonjs/core/Maths/math.vector';
import type { IVector3, IVector4 } from '@seddi/math-v2';

/**
 * Create vector3.
 * @param v - Value.
 */
export const createVector3 = (v: IVector3): Vector3 => {
  return new Vector3(v.x, v.y, v.z);
};

/**
 * Create quaternion.
 * @param v - Value.
 */
export const createQuaternion = (v: IVector4): Quaternion => {
  return new Quaternion(v.x, v.y, v.z, v.w);
};
